/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";

const { isAuthenticated } = {};

const LandingPage = lazy(() => import("../pages/LandingPage"));
const EntertainmentPage = lazy(() => import("../pages/Entertainment"));
const CollectiblesPage = lazy(() => import("../pages/Collectibles"));
const SportsPage = lazy(() => import("../pages/Sports"));
const ProductDetailPage = lazy(() => import("../pages/ProductDetail"));
const WalletPage = lazy(() => import("../pages/MyWallet"));
const SportsDetailPage = lazy(() => import("../pages/SportsDetail"));
const EntertainmentDetailPage = lazy(
    () => import("../pages/EntertainmentDetail")
);
const TermsPage = lazy(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazy(() => import("../pages/PrivacyPolicy"));
const ScrollToTop = lazy(() => import("./ScrollToTop"));
const MyProfilePage = lazy(() => import("../pages/MyProfile"));
const MyTransactionPage = lazy(() => import("../pages/MyTransactions"));
const MyProductDetailpage = lazy(() => import("../pages/MyProductDetail"));
const ProductTransactionDetailPage = lazy(
    () => import("../pages/ProductTransactionDetail")
);
const Login = lazy(() => import("../pages/login"));
const LogoutPage = lazy(() => import("../pages/Logout"));

const RouterConfig = (props) => (
    <Switch>
        <Route exact path="/entertainment" component={EntertainmentPage} />
        <Route
            exact
            path="/entertainment/product"
            component={EntertainmentDetailPage}
        />
        <Route exact path="/sports" component={SportsPage} />
        <Route exact path="/sports/product" component={SportsDetailPage} />
        <Route exact path="/collectibles" component={CollectiblesPage} />
        <Route
            exact
            path="/collectibles/product"
            component={ProductDetailPage}
        />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route exact path="/my-wallet" component={WalletPage} />
        <Route exact path="/my-profile" component={MyProfilePage} />
        <Route exact path="/my-transactions" component={MyTransactionPage} />
        <Route
            exact
            path="/my-product-details"
            component={MyProductDetailpage}
        />
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={LogoutPage} />
        <Route
            exact
            path="/my-product-transaction-details"
            component={ProductTransactionDetailPage}
        />
        <Route path="/" component={LandingPage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/login`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW />}>
                <ScrollToTop />
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
